export default "/static/1dbfd59d57ccbf4c.png"